export default __webpack_public_path__ + "static/media/activity-2.d77ff49d.png";